import axios from 'axios';
import { message } from 'antd';
import config from '../config';
import { getCookie, getQueryString } from './utils';

const options: {
    timeout: number;
    baseURL: string | undefined;
} = {
    timeout: 30000, // 设置超时时间10s
    baseURL: config.API_BASE_URL,
    // baseURL: 'http://192.168.1.65:9015'
};

const instance = axios.create(options);

instance.defaults.headers.post['Content-Type'] = 'application/json';

/** 添加请求拦截器 **/
instance.interceptors.request.use((config: any) => {
    if (config.method === 'delete') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    if (getCookie('memToken') || getQueryString('memToken')) {
        config.headers.token = getCookie('memToken') || getQueryString('memToken');
    }
    if (localStorage.getItem('sessionId') && localStorage.getItem('sessionId') !== 'null') {
        config.headers.sessionId = getCookie('authentication_member_card') || getQueryString('memCard') || localStorage.getItem('sessionId');
    }
    // 预览
    if (getQueryString('type') && getQueryString('type') === '1') {
        config.headers.sessionId = 9999999999999999999;
    }
    // 健学云 - 问卷权限
    if (config.url.includes('api/survey/questions')) {
        config.headers.resource = 'JXY';
        config.headers.projectId = getQueryString('projectId');
    }
    return config;
});

/** 添加响应拦截器  **/
instance.interceptors.response.use(
    (response: any) => {
        if (!response.config.url.includes('download')) {
            if (response.data.status_code === 200) {
                return Promise.resolve(response.data);
                // 401 未登录/token过期
            } else if (response.data.status_code === 401) {
                if (window.location.pathname.includes('/answerMvp')) {
                    loginTrain();
                } else {
                    login();
                }
                return Promise.reject(response.data.message);
            } else if (response.data.status_code === 400) {
                message.error(response.data.message);
                return Promise.reject(response.data.message);
            } else if (response.data.status_code === 403) {
                message.error(response.data.message);
                return Promise.reject(response.data.message);
                // 405 非个人专业认证
            } else if (response.data.status_code === 405) {
                isAuth();
                return Promise.reject(response.data.message);
                // 406 未提交个人专业认证信息
            } else if (response.data.status_code === 406) {
                isAuth();
                return Promise.reject(response.data.message);
                // 科室不匹配
            } else if (response.data.status_code === 407) {
                isPost();
                message.error(response.data.message);
                return Promise.reject(response.data.message);
                // 职务不匹配
            } else if (response.data.status_code === 408) {
                isPost();
                message.error(response.data.message);
                return Promise.reject(response.data.message);
                // 职称不匹配
            } else if (response.data.status_code === 409) {
                isPost();
                message.error(response.data.message);
                return Promise.reject(response.data.message);
            } else if (response.data.status_code === 410) {
                isWhite();
                message.error(response.data.message);
                return Promise.reject(response.data.message);
                // 411 只能作答一次
            } else if (response.data.status_code === 411) {
                if (window.location.pathname.includes('/answerMvp')) {
                    onlyAnswerTrain();
                } else {
                    onlyAnswer();
                }
                message.error(response.data.message);
                return Promise.reject(response.data.message);
            } // 问卷已下架/未发布
            else if (response.data.status_code === 412) {
                message.error(response.data.message);
                window.location.replace(`/s/error?type=${2}`);
                return Promise.reject(response.data.message);
            }
            // 认证审核中
            else if (response.data.status_code === 416) {
                message.error(response.data.message);
                window.location.replace(`/s/error?type=${5}`);
                return Promise.reject(response.data.message);
            } else {
                message.error(response.data.message);
                return Promise.reject(response.data.message);
            }
        } else {
            return Promise.resolve(response.data);
        }
    },
    error => {
        return Promise.reject('请求超时, 请刷新重试');
    },
);

// 调研组件登录
const login = () => {
    const isAnswer = window.location.pathname.includes('/answer');
    if (isAnswer) {
        // window.location.href = window.location.href.replaceAll('/answer', '');
        const href = window.location.href.replaceAll('/answer', '');
        if (getCookie('platform') === 'cn-healthcare') {
            window.location.href = 'native://login?sourceId=101001';
        } else {
            window.location.href = `${config.UCENTER_URL}/rlogin/logout?redirectUrl=${encodeURIComponent(href)}`;
        }
        return;
    }

    if (getCookie('platform') === 'cn-healthcare') {
        window.location.href = 'native://login?sourceId=101001';
    } else {
        // 小程序环境
        if (typeof (window as any).wx !== 'undefined' && (window as any).wx.miniProgram) {
            (window as any).wx.miniProgram.getEnv((res: any) => {
                if (res.miniprogram) {
                    (window as any).wx.miniProgram.navigateTo({
                        url: '/pages/login/index',
                    });
                } else {
                    window.location.href = `${config.UCENTER_URL}/rlogin/logout?redirectUrl=${encodeURIComponent(window.location.href)}`;
                }
            });
        } else {
            window.location.href = `${config.UCENTER_URL}/rlogin/logout?redirectUrl=${encodeURIComponent(window.location.href)}`;
        }
    }
};

// 培训任务 - 调研登录逻辑
const loginTrain = () => {
    const isAnswerMvp = window.location.pathname.includes('/answerMvp');
    if (isAnswerMvp) {
        let url = `${config.UCENTER_URL}/rlogin/tologinforajax?pingtaif=jxy&sms=0&redirectUrl=${config.HEALTHCLASS_URL_PREFIX}/entry-auth`;
        window.location.href = url;
        return;
    }
};

// 仅作答一次
const onlyAnswer = () => {
    let pathname = window.location.pathname;
    let surveyId = undefined;
    if (pathname.includes('/answer')) {
        let curUrl: any = pathname.replaceAll('/answer', '');
        surveyId = curUrl.match(/s\/(.*)/)[1];
    } else {
        let curUrl: any = pathname.replaceAll('/', '');
        surveyId = curUrl.match(/s(.*)/)[1];
    }
    window.location.replace(`/s/error?type=${1}&surveyId=${surveyId}`);
};

// 培训任务 - 仅作答一次
const onlyAnswerTrain = () => {
    let pathname = window.location.pathname;
    let surveyId = undefined;
    if (pathname.includes('/answerMvp')) {
        let curUrl: any = pathname.replaceAll('/answerMvp', '');
        surveyId = curUrl.match(/s\/(.*)/)[1];
    } else {
        let curUrl: any = pathname.replaceAll('/', '');
        surveyId = curUrl.match(/s(.*)/)[1];
    }
    window.location.replace(`/s/error?type=${1}&surveyId=${surveyId}`);
};

// 白名单跳转封面
const isWhite = () => {
    // const isAnswer = window.location.pathname.includes('/answer');
    // if (isAnswer) {
    //     window.location.href = window.location.href.replaceAll('/answer', '');
    // };
    window.location.replace(`/s/error?type=${3}`);
};

// 职务不匹配
const isPost = () => {
    // const isAnswer = window.location.pathname.includes('/answer');
    // if (isAnswer) {
    //     window.location.href = window.location.href.replaceAll('/answer', '');
    // };
    window.location.replace(`/s/error?type=${4}`);
};

// 认证跳转
const isAuth = () => {
    const isAnswer = window.location.pathname.includes('/answer');
    if (isAnswer) {
        window.location.href = window.location.href.replaceAll('/answer', '');
    } else {
        window.location.href = `${config.USERCENTER_PREFIX}/m/certificate?backUrl=${encodeURIComponent(window.location.href)}`;
    }
};

/* 统一封装get请求 */
export const get = async (url: string, params: any) => {
    let urlStr = url + '?';
    for (let i in params) {
        if (params[i] !== undefined) {
            urlStr += `${i}=${params[i]}&`;
        }
    }
    urlStr = urlStr.slice(0, urlStr.length - 1);
    try {
        let result = await instance.get(urlStr);
        return result;
    } catch (err) {
        return err;
    }
};

/* 统一封装post请求  */
export const post = async (url: string, data: any, options?: any) => {
    try {
        let result = await instance.post(url, data, options);
        return result;
    } catch (err) {
        return err;
    }
};

/* 统一封装put请求  */
export const put = async (url: string, data: any) => {
    try {
        let result = await instance.put(url, data);
        return result;
    } catch (err) {
        return err;
    }
};

/* 统一封装delete请求  */
export const del = async (url: string, params: any) => {
    let urlStr = url + '?';
    for (let i in params) {
        if (params[i] !== undefined) {
            urlStr += `${i}=${params[i]}&`;
        }
    }
    urlStr = urlStr.slice(0, urlStr.length - 1);
    try {
        let result = await instance.delete(urlStr);
        return result;
    } catch (err) {
        return err;
    }
};

export const patch = async (url: string, data: any) => {
    try {
        let result = await instance.patch(url, data);
        return result;
    } catch (err) {
        return err;
    }
};
